import { genId } from '@/js/util.js';


export class CollapsingDiv {
    constructor(title, default_collapsed) {
        this.id = 'collapsing_div_'+genId();
        this.title = title;
        this.is_collapsed = default_collapsed ?? true;

        /* Setup */ {
            const wrapper = document.createElement('div');
            wrapper.id = this.id;
            this.wrapper_elem = wrapper;

            const heading_elem = document.createElement('div');
            heading_elem.classList.add('d-flex', 'justify-content-between');
            heading_elem.classList[this.is_collapsed ? 'add' : 'remove']('opacity-50');
            wrapper.appendChild(heading_elem);
            this.heading_elem = heading_elem;

            const title_elem = document.createElement('h4');
            title_elem.textContent = this.title;
            heading_elem.appendChild(title_elem);
            this.title_elem = title_elem;

            const collapse_button = document.createElement('button');
            collapse_button.style.width = '30px';
            collapse_button.style.height = '30px';
            heading_elem.appendChild(collapse_button);
            this.collapse_button = collapse_button;

            const collapse_button_icon = document.createElement('img');
            collapse_button_icon.classList.add('fa-icon');
            collapse_button_icon.src = 'static/icons/' + (this.is_collapsed ? 'chevron-up.svg' : 'chevron-down.svg');
            collapse_button_icon.src = 'static/icons/' + (this.is_collapsed ? 'chevron-up.svg' : 'chevron-down.svg');
            this.collapse_button_icon = collapse_button_icon;
            collapse_button.appendChild(collapse_button_icon);

            collapse_button.addEventListener('click', () => {
                this[this.is_collapsed ? 'expand' : 'collapse']();
            });

            const body_elem = document.createElement('div');
            body_elem.style.display = (this.is_collapsed ? 'none' : 'block');
            wrapper.appendChild(body_elem);
            this.body_elem = body_elem;
        }
    }

    setTitle(new_title) {
        this.title_elem.textContent = new_title;
        this.title = new_title;
    }

    clearBody() {
        this.body_elem.replaceChildren();
    }

    appendNode(node) {
        this.body_elem.appendChild(node);
    }

    appendHtml(html) {
        const node = document.createElement('div');
        node.innerHTML = html;
        this.appendNode(node);
    }

    prependNode(node) {
        const first_child = this.body_elem.firstChild;
        if(first_child) {
            this.body_elem.insertBefore(node, first_child);
        } else {
            this.body_elem.appendChild(node);
        }
    }

    prependHtml(html) {
        const node = document.createElement('div');
        node.innerHTML = html;
        this.prependNode(node);
    }

    collapse() {
        this.body_elem.style.display = 'none';
        this.collapse_button_icon.src = 'static/icons/chevron-up.svg';
        this.heading_elem.classList.add('opacity-50');
        this.is_collapsed = true;
    }

    expand() {
        this.body_elem.style.display = 'block';
        this.collapse_button_icon.src = 'static/icons/chevron-down.svg';
        this.heading_elem.classList.remove('opacity-50');
        this.is_collapsed = false;
    }
}
